import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { TranslateService } from '@ngx-translate/core';
import { PageBase } from '../page-base';
import { Sorting, By, Direction } from '../../providers/sorting/sorting';

@Component({
  template: `
    <ion-list radio-group [(ngModel)]="alg" (ionChange)="sort()">
      <ion-list-header><div translate>SORTING.TITLE</div></ion-list-header>
      <ion-item *ngFor="let item of algorithms">
        <ion-label>{{item.name}}</ion-label>
        <ion-radio value="{{item.value}}"></ion-radio>
      </ion-item>
    </ion-list>
  `
})

export class SortingPopoverPage extends PageBase {

  algorithms = new Array<{ name: string, value: string }>();
  alg: string;
  current: string;

  private handler: (alg: string) => void;

  constructor(private viewCtrl: ViewController, private navParams: NavParams) {
    super();
    this.handler = this.navParams.get('cb');
    this.current = this.navParams.get('current');
    this.alg = this.current;
    this.algorithms.push({ name: this.translate.instant('SORTING.DEFAULT'), value: new Sorting(By.DEFAULT, Direction.ASCENDING).toValue() });
    this.algorithms.push({ name: this.translate.instant('SORTING.NAME_ASC'), value: new Sorting(By.NAME, Direction.ASCENDING).toValue() });
    this.algorithms.push({ name: this.translate.instant('SORTING.NAME_DESC'), value: new Sorting(By.NAME, Direction.DESCENDING).toValue() });
    this.algorithms.push({ name: this.translate.instant('SORTING.PRICE_ASC'), value: new Sorting(By.PRICE_INC_VAT, Direction.ASCENDING).toValue() });
    this.algorithms.push({ name: this.translate.instant('SORTING.PRICE_DESC'), value: new Sorting(By.PRICE_INC_VAT, Direction.DESCENDING).toValue() });
  }

  /**
  * Closes popover.
  */
  close() {
    this.viewCtrl.dismiss();
  }

  /**
  * Executes the handler if the algorithm selection changed. Then closes popover.
  */
  sort() {
    if (this.alg != this.current) {
      this.handler(this.alg);
      this.current = this.alg;
      this.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/category/sorting-popover.ts